class Tabs {
  constructor(options) {
    this.container = options.container;
    this.index = options.index;
    this.startPaneIndex = this.index || 0;
    this.tabSelectors = this.container.querySelectorAll('[data-tab-selector]');
    this.tabPanes = this.container.querySelectorAll('[data-tab-pane]');

    this.state = {
      currentTabPane: null,
      quantity: this.tabSelectors.length,
    };
  }

  init = () => {
    this.refresh();
    [...this.tabSelectors].forEach(el => el.addEventListener('click', this.selectorClickHandler));
  };

  changeTabPane = i => {
    const removeNodeData = (node, attrName) => node.removeAttribute(attrName);
    const addNodeData = (node, attrName, value) => node.setAttribute(attrName, value);

    if (this.state.currentTabPane !== null) {
      Array.prototype.slice.call(this.tabSelectors).forEach(el => {
        removeNodeData(el, 'data-tab-selector--is-active');
        addNodeData(el, 'aria-selected', false);
      });

      Array.prototype.slice.call(this.tabPanes).forEach(el => {
        removeNodeData(el, 'data-tab-pane--is-active');
        addNodeData(el, 'aria-hidden', true);
      });
    }

    this.state.currentTabPane = i;
    addNodeData(this.tabSelectors[i], 'data-tab-selector--is-active', '');
    addNodeData(this.tabSelectors[i], 'aria-selected', true);
    addNodeData(this.tabPanes[i], 'data-tab-pane--is-active', '');
    addNodeData(this.tabPanes[i], 'aria-hidden', false);
  };

  selectorClickHandler = e => {
    const { target } = e;
    this.state.currentTabPane = +target.dataset.tabSelectorId;
    if (target && !target.hasAttribute('data-tab-selector--is-active')) {
      this.changeTabPane(this.state.currentTabPane);
    }
  };

  unBindHandlers = () => {
    [...this.tabSelectors].forEach(el => el.addEventListener('click', this.selectorClickHandler));
  };

  refresh = () => {
    this.unBindHandlers();

    for (let i = 0; i < this.state.quantity; i++) {/* eslint-disable-line */
      if (this.tabSelectors[i].hasAttribute('data-tab-selector--is-active'))
        this.tabSelectors[i].removeAttribute('data-tab-selector--is-active');
      if (this.tabPanes[i].hasAttribute('data-tab-pane--is-active'))
        this.tabPanes[i].removeAttribute('data-tab-pane--is-active');

      this.tabSelectors[i].setAttribute('data-tab-selector-id', i);
      this.tabPanes[i].setAttribute('data-tab-pane-id', i);
    }

    this.changeTabPane(this.startPaneIndex);
  };
}

export default Tabs;
